<template>
  <div>
    <titulo-modulo
      :titulo="$route.params.id > 0 ? 'Editar Documento' : 'Enviar Documento'"
    />

    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <v-row v-else>
      <v-col class="pt-0">
        <v-btn
          rounded
          color="error"
          :to="{ name: 'documentos' }"
          max-height="35"
          >Cancelar</v-btn
        >
      </v-col>
      <v-col cols="12" class="pt-0" v-if="podeEditar">
        <v-stepper v-model="stepModel" vertical class="mt-2">
          <selecionar-tipo-atestado />
          <anexar-documentos />
        </v-stepper>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import TituloModulo from "../../../../src/components/TituloModulo.vue";
import SelecionarTipoAtestado from "../../atestados/enviar-atestado/components/SelecionarTipoAtestado.vue";
import AnexarDocumentos from "../../atestados/enviar-atestado/components/StepAnexarDocumentos.vue";
import moment from "moment";

export default {
  computed: {
    ...mapState("atestado", [
      "step",
      "atestadoEnviar",
      "configs",
      "screens",
      "atestados",
      "atestSelec",
      "dados",
    ]),
    stepModel: {
      get: function () {
        return this.step;
      },
      set: function (value) {
        this.setStep(value);
      },
    },
  },
  components: {
    TituloModulo,
    SelecionarTipoAtestado,
    AnexarDocumentos,
  },
  data: () => ({
    carregando: false,
    podeEditar: true,
  }),
  methods: {
    ...mapMutations("atestado", [
      "setStep",
      "setScreens",
      "setAtestSelec",
      "setScreen",
      "setDados",
    ]),
    ...mapMutations("anexos", ["setDocs"]),
    ...mapActions("atestado", ["getConfigs", "getAtestados"]),
    ...mapGetters("atestado", ["getTipoSelecionado"]),
  },
  async mounted() {
    this.carregando = true;
    this.setDados("OUTROS DOCUMENTOS");
    await this.getConfigs();
    this.setScreens();
    this.setStep(this.screens[0]);

    this.setAtestSelec(null);
    this.setScreen(0);
    this.atestadoEnviar.tipo = 0;
    this.atestadoEnviar.motivo = 0;
    this.atestadoEnviar.dependente = 0;
    this.atestadoEnviar.datainicial = moment().format("YYYY-MM-DD");
    this.atestadoEnviar.diasatestado = 1;
    this.atestadoEnviar.datafinal = moment().format("YYYY-MM-DD");
    this.atestadoEnviar.cid = "";
    this.atestadoEnviar.codMedico = 0;
    this.atestadoEnviar.nomeMedico = "";
    this.atestadoEnviar.crmcro = "";
    this.atestadoEnviar.ddd = "";
    this.atestadoEnviar.telefone = "";
    this.atestadoEnviar.justificativa = "Documento Enviado";
    this.setDocs([]);

    if (this.$route.params.id > 0) {
      await this.getAtestados();

      this.setAtestSelec(
        this.atestados.find(
          (atest) => atest.codigo == this.$route.params.id && atest.status === 2
        )
      );

      if (this.atestSelec) {
        this.atestadoEnviar.tipo = this.atestSelec.codconfigatest;
        this.setDocs(this.atestSelec.anexos);
      } else this.podeEditar = false;
    }

    this.carregando = false;
  },
};
</script>


    